import { render, staticRenderFns } from "./global-data-packet.vue?vue&type=template&id=edcbdf46"
import script from "./global-data-packet.vue?vue&type=script&lang=js"
export * from "./global-data-packet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports